<template>
    <div class="card card-with-table">
        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Продукт</th>
                        <th>Цена</th>
                        <th class="d-none d-sm-table-cell">Себестоимость</th>
                        <th class="d-none d-sm-table-cell">Дата</th>
                        <th class="d-none d-sm-table-cell">Тип оплаты</th>
                        <th v-if="hasCrt" class="d-none d-sm-table-cell">Чек</th>
                    </tr>
                </thead>

                <tbody v-if="vends.length !== 0">
                    <tr v-for="vend in vends" :key="vend.id">
                        <td>{{ vend.product_number }}</td>
                        <td>{{ vend.product_name }}</td>
                        <td class="align-middle text-primary">{{ vend.price | money }} {{ currency | currencySymbol }}</td>
                        <td class="d-none d-sm-table-cell align-middle text-primary">
                            <span v-if="vend.net_price">
                                {{ vend.net_price | money }} {{ currency | currencySymbol }}
                            </span>

                            <span v-else class="text-muted">—</span>
                        </td>
                        <td class="d-none d-sm-table-cell">{{ vend.local_time | date('DD.MM.YYYY HH:mm') }}</td>
                        <td class="d-none d-sm-table-cell">{{ vend.payment_type | paymentType }}</td>

                        <td v-if="hasCrt" class="d-none d-sm-table-cell">
                            <template v-if="vend.order && vend.order.state === 3">
                                <vend-fiscal-details :value="vend.order.fiscal" />
                            </template>

                            <template v-if="vend.order && vend.order.state !== 3">
                                <i v-if="vend.order.state === 4" :title="vend.order.error" class="tlm-icon-minus-circle text-danger" />
                                <i v-else class="tlm-icon-spinner-animate text-muted" />
                            </template>
                        </td>
                    </tr>
                </tbody>

                <tfoot class="text-center text-muted">
                    <tr>
                        <td colspan="42">
                            <slot name="moar" />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import VendFiscalDetails from '@/components/VendFiscalDetails'

export default {
    components: {
        VendFiscalDetails
    },

    props: {
        vends: {
            type: Array,
            default: _ => []
        },

        hasCrt: {
            type: Boolean,
            default: false
        },

        currency: {
            type: Number,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
.table-vend-list {
    thead {
        th {
            line-height: 1rem;
            vertical-align: middle;

            &:nth-child(2) {
                width: 100%;
            }

            &:nth-child(5) {
                width: 150px;
            }
        }
    }

    tbody {
        tr {
            td {
                vertical-align: middle;
            }
        }
    }
}
</style>
